<template>
  <input class="input" type="tel" :value="initialValue" :placeholder="placeholder"/>
</template>

<script>
  export default {
    props: ['value', 'mask', 'placeholder'],
    watch: {
      value: function (value) {
        this.initialValue = value;
      }
    },
    data() {
      return {
        initialValue: ''
      }
    },
    created() {
      this.initialValue = this.value;
    },
    mounted() {
      let that = this;
      let input = $(this.$el);

      input.on('change', function (e) {
        let value = e.target.value;
        that.$emit('input', value);
      });

      input.mask(this.mask);

    },
    methods: {
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/InputMask.vue